// Cached responses from older bundles can still say promotionEligible=true.
// The backend rechecks the same rule before selection and handoff.
export function hasPaidPromotionExtras(order = {}) {
    const hasExtras = (details = {}) => {
        const language = (details.translationLanguage || '').trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return details.apostila === true || details.legalized === true
            || (language !== '' && language !== 'romana' && language !== 'romania');
    };
    return hasExtras(order) || hasExtras(order.details || {});
}
